import React, { useEffect } from 'react';

export let onAlertVisible = () => { };

export const registerOnAlertVisible = (fn) => {
    onAlertVisible = fn;
};

const Alerts = ({ visible, title = "Error", message, message2, message3, onClose, showFooterButton = false, data }) => {
    useEffect(() => {
        if (visible) {
            onAlertVisible();
        }
    }, [visible]);

    if (!visible) return null;

    async function lambdaCaller({ filename, filenameKey }) {
        const url = 'url';
        const data = {
            fielName: filename,
            fileKey: filenameKey
        };

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            });

            const result = await response.json();
            console.log('Lambda Response:', result);
        } catch (error) {
            console.error('Error invoking Lambda:', error);
        }
    }

    return (
        <div id='curtain' className="visibleModal" >
            <div className="alertBg">
                <div className="alertBox">
                    <div className="alertHeader">
                        <h2 className="alertTitle">{title}</h2>
                        <button className="alertCloseBtn" onClick={onClose}>X</button>
                    </div>

                    <div className="alertBody">
                        <p>{message}</p>
                        {message2 && <p>{message2}</p>}
                        {message3 && (
                            <div className="alertBodyExtra">
                                {Array.isArray(message3)
                                    ? message3.map((linea, index) => <p key={index}>{linea}</p>)
                                    : <p>{message3}</p>}
                            </div>
                        )}
                    </div>
                    <div className="alertFooter">
                        {showFooterButton && (
                            <button
                                className="alertMainBtn"
                                onClick={() => lambdaCaller(data)}
                            >
                                Aceptar
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Alerts;
